"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileTableContext = void 0;
const react_1 = require("react");
exports.FileTableContext = (0, react_1.createContext)({});
//# sourceMappingURL=file-table-context.js.map